// tslint:disable: max-line-length
import { DOCUMENT } from "@angular/common";
import { Component, Inject, NgZone, OnInit } from "@angular/core";
import { SeoService } from "src/app/services/seo/seo.service";

@Component({
  selector: "app-what-de",
  templateUrl: "./what-de.component.html",
  styleUrls: ["./what-de.component.scss"],
})
export class WhatDeComponent implements OnInit {
  public statetoshow = "ideation";
  private slides: NodeListOf<Element>;

  constructor(
    private ngZone: NgZone,
    @Inject("isBrowser") private isBrowser: boolean,
    @Inject(DOCUMENT) private document: Document,
    private seo: SeoService,
  ) {}

  ngOnInit() {
    this.seo.updateMeta({
      title: "coara - was wir tun",
      description: "Wir glauben an Ihre Vision. Wir sind leidenschaftlich innovativ und möchten Ihre Ideen Wirklichkeit werden lassen.",
      imageUrl: "https://coara.co/assets/images/sharing/facebook.jpg",
    });
    this.seo.setCanonicalURL();
    this.slides = this.document.querySelectorAll(".-slide");
    if (this.isBrowser) {
      window.addEventListener("scroll", this.onWindowScroll.bind(this), true);
    }
  }

  private onWindowScroll(): void {
    const offset = window.innerWidth > 700 ? 400 : 0;
    this.slides.forEach(slide => {
      if (
        slide.getBoundingClientRect().top <= offset &&
        slide.getBoundingClientRect().bottom >= offset &&
        this.statetoshow !== slide.getAttribute("statetoshow")
      ) {
        this.ngZone.run(() => (this.statetoshow = slide.getAttribute("statetoshow")));
      }
    });
  }
}
